<template>
    <div>
      <q-header v-if="$q.screen.sm || $q.screen.md || $q.screen.lg || $q.screen.xl" elevated class="bg-white text-black header-text shadow-2" style="padding: 15px 90px;">
        <!-- <q-toolbar>
        <q-toolbar-title> 
          <router-link to="/">
          <q-img src="img/marina.png" style="height: auto; max-width: 125px" />
          </router-link>
          <q-input
            v-model="cari_value"
            debounce="500"
            outlined
            :dense="true"
            class="cari-data bg-white"
            color="purple-12"
            placeholder="Cari Produk..."
          >
            <template v-slot:append>
              <q-icon name="search" style="font-size: 18px;" color="purple-12" />
            </template>
          </q-input>
        </q-toolbar-title> 
          <q-tabs align="left" no-caps outside-arrows mobile-arrows active-color="purple-12">
            <q-route-tab to="/" label="Beranda" />
            <q-route-tab to="/produk" label="Produk" />
            <q-route-tab to="/kategori" label="Kategori" />
            <q-route-tab to="/pelaku_usaha" label="Pelaku Usaha" />
          </q-tabs>
        </q-toolbar> -->
        <div class="row no-wrap">
        <q-toolbar class="col-2">
          <q-toolbar-title> 
            <router-link to="/">
            <q-img src="img/marina.png" style="height: auto; max-width: 125px" />
            </router-link>
          </q-toolbar-title>
        </q-toolbar>
        <q-toolbar class="col-6">
          <q-input
            v-model="cari_value"
            debounce="500"
            outlined
            :dense="true"
            class="cari-data bg-white"
            color="purple-12"
            @keydown.enter="submit('myInput')" ref="myInput"
            placeholder="Cari Produk..."
          >
            <template v-slot:append>
              <q-icon name="search" style="font-size: 18px;" color="purple-12" />
            </template>
          </q-input>
        </q-toolbar>
        <q-toolbar class="col-4">
          <q-space />
          <q-tabs no-caps outside-arrows mobile-arrows inline-label active-color="purple-12">
            <q-route-tab to="/akun" label="Akun" icon="sym_o_person" />
            <q-route-tab to="/wishlist" label="Wishlist" icon="sym_o_favorite" />
            <q-route-tab to="/keranjang" icon="sym_o_shopping_cart" label="Keranjang" />
            <q-route-tab v-if="cek_login == 1" to="/login" class="text-purple-12" icon="lock" >
              <q-tooltip
                transition-show="flip-right"
                transition-hide="flip-left"
                class="bg-purple-12 text-white"
              >
                Login
              </q-tooltip>
            </q-route-tab>
          </q-tabs>
        </q-toolbar>
      </div>
      </q-header>
      <q-header v-if="$q.screen.lt.sm" elevated class="bg-white text-black header-text shadow-1" style="padding: 10px 20px 10px 10px;">
        <div class="row no-wrap">
          <q-toolbar class="col-4">
            <q-toolbar-title>
              <router-link to="/">
                <q-img src="img/marina.png" style="height: auto; max-width: 200px" />
              </router-link>
            </q-toolbar-title> 
          </q-toolbar>
          <q-toolbar class="col-6">
            <q-input
              v-model="cari_value"
              debounce="500"
              outlined
              :dense="true"
              class="cari-data bg-white"
              color="purple-12"
              @keydown.enter="submit('myInput')" ref="myInput"
              placeholder="Cari Produk..."
            >
              <template v-slot:append>
                <q-icon name="search" style="font-size: 18px;" color="purple-12" />
              </template>
            </q-input>
          </q-toolbar>
          <q-toolbar class="col-2">
            <q-space />
            <q-btn dense flat round icon="menu" @click="rightDrawerOpen = !rightDrawerOpen"  />
          </q-toolbar>
        </div>
      </q-header>
      <q-drawer v-model="rightDrawerOpen" side="right" width="250" overlay behavior="mobile" elevated>
        <q-scroll-area class="fit"> 
              <q-list class="q-pa-sm">
                  <q-item clickable to="/akun" active-class="text-purple-12" v-ripple>
                    <q-item-section avatar>
                      <q-icon name="sym_o_person" />
                    </q-item-section>
                    <q-item-section>
                      Akun
                    </q-item-section>
                  </q-item>
                  <q-separator />
                  <q-item clickable to="/wishlist" active-class="text-purple-12" v-ripple>
                    <q-item-section avatar>
                      <q-icon name="sym_o_favorite" />
                    </q-item-section>
                    <q-item-section>
                      Wishlist
                    </q-item-section>
                  </q-item>
                  <q-separator />
                  <q-item clickable to="/keranjang" active-class="text-purple-12" v-ripple>
                    <q-item-section avatar>
                      <q-icon name="sym_o_shopping_cart" />
                    </q-item-section>
                    <q-item-section>
                      Keranjang
                    </q-item-section>
                  </q-item>
                  <q-separator v-if="cek_login == 1" />
                  <q-item v-if="cek_login == 1" clickable to="/login" class="text-purple-12 text-weight-bold" v-ripple>
                    <q-item-section avatar>
                      <q-icon name="lock" color="purple-12" />
                    </q-item-section>
                    <q-item-section>
                      Login
                    </q-item-section>
                  </q-item>
                </q-list>
        </q-scroll-area>      
    </q-drawer>   
    </div>
</template>

<script>
 
export default {
    name: "Header",

  data() {
    return {
      rightDrawerOpen:false,
      cek_login : 0,
      cari_value : '',
      datadata : 'DATA PROPS',
      artists: [
        { name: "Davido", genre: "afrobeats", country: "Nigeria" },
        { name: "Burna Boy", genre: "afrobeats", country: "Nigeria" },
        { name: "AKA", genre: "hiphop", country: "South-Africa" },
        { name: "Sarkodie", genre: "hiphop", country: "Ghana" },
        { name: "Stormzy", genre: "hiphop", country: "United Kingdom" },
        { name: "Lil Nas", genre: "Country", country: "United States" },
        { name: "Nasty C", genre: "hiphop", country: "South-Africa" },
        { name: "Shatta-walle", genre: "Reagae", country: "Ghana" },
        { name: "Khalid", genre: "pop", country: "United States" },
        { name: "Ed Sheeran", genre: "pop", country: "United Kingdom" },
      ],
    }
  },
  methods: {

    // cari_data : function(){
    //     // this.kirimWa();
    //     localStorage.cari = JSON.stringify(this.cari_value);

    //     this.$router.push('/pencarian');
    //   },

      submit(refKey) {
        console.log("APA YANG TERJADI DISINI GESS");
      //Setting the variable only when submitted
      this.cari_value = this.$refs[refKey].model;
      localStorage.cari = JSON.stringify(this.cari_value)
      this.$router.push('/pencarian');
    }
 
  },

  mounted: function(){
    if (localStorage.token == undefined) {
      this.cek_login = 1;
    } else {
      this.cek_login = 0 
    }
  },
}
</script>